import { Box } from "@mui/material";
import { useMemo } from "react";
import PrimaryCaption from "../field-captions/PrimaryCaption.tsx";
import { getDefaultCaption } from "./AreaFieldsHelper.ts";
import type { FieldItemProps } from "./areaFiledItem.types.ts";

const FieldItemCaptions = <T,>({
  field,
  formatCaption,
  disableEqualitySelection,
}: Pick<FieldItemProps<T>, "field" | "formatCaption" | "disableEqualitySelection">) => {
  const defaultCaption = useMemo(() => getDefaultCaption(field), [field]);
  const customCaption = formatCaption && formatCaption(field, undefined, disableEqualitySelection);

  if (customCaption) {
    return customCaption;
  }

  return (
    <Box sx={{ px: 0.8, flex: 1, minWidth: 0 }}>
      <PrimaryCaption text={defaultCaption} />
    </Box>
  );
};

export default FieldItemCaptions;
